const initialState = {
    loading: false,
    options: [],
    error: null,
};

export default function selectListReducer (state = initialState, action) {
    switch (action.type) {
        case 'FETCH_SELECT_LIST_REQUEST':
            return { ...state, loading: true, error: null };
        case 'FETCH_SELECT_LIST_SUCCESS':
            return { ...state, loading: false, options: action.payload };
        case 'FETCH_SELECT_LIST_FAILURE':
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};
